import React, { useEffect, useState, useContext } from "react";
import { useLocation, matchPath, useNavigate } from "react-router-dom";
import { AiFillTablet } from "react-icons/ai";
import PropTypes from "prop-types";
import SettingsContext from "src/context/SettingsContext";
import { UserContext } from "src/context/User";
import NavItem from "./NavItem";
import { Box, Button, Collapse, Dialog, DialogActions, DialogContent, Drawer, List, ListItem, ListSubheader, Slide, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import ApiConfig from "src/config/APIConfig";
import axios from "axios";
import toast from "react-hot-toast";
import LogoutIcon from '@mui/icons-material/Logout';
import { RiArrowDropDownLine } from "react-icons/ri";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import GroupIcon from "@mui/icons-material/Group";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import BarChartIcon from "@mui/icons-material/BarChart";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import AssignmentReturnOutlinedIcon from "@mui/icons-material/AssignmentReturnOutlined";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import ErrorIcon from "@mui/icons-material/Error";
import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import { PREFIX } from "src/components/Config";
// import { setProfileImage } from "src/store/slices/usersSlice";
function renderNavItems({ items, pathname, depth = 0, state, setSelectedTab }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) =>
          reduceChildRoutes({
            acc,
            item,
            pathname,
            depth,
            state,
            setSelectedTab,
          }),
        []
      )}
    </List>
  );
}
const ImgTag = styled("img")(({ theme }) => ({
  cursor: "pointer",
}));
function reduceChildRoutes({
  acc,
  pathname,
  item,
  depth,
  state,
  setSelectedTab,
}) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false,
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
          state,
          setSelectedTab,
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        info={item.info}
        tabview={item.tabview}
        key={key}
        title={item.title}
        setSelectedTab={(item) => setSelectedTab(item)}
      />
    );
  }
  return acc;
}
const styles = {
  main: {},
  desktopDrawer: {
    width: "270px",
    height: "100%",
    background: "#232B3B",
    boxShadow: "0px 10px 30px 0px rgba(0, 0, 0, 0.10)",
    "& .lightlogoutButton": {
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
      position: "absolute",
      bottom: "19px",
      left: "17px",
      borderRadius: "5px",
      fontWeight: "400",
      fontSize: "13px",
      color: "#fff",
      backgroundColor: "#151515",
    },
    "& .darklogoutButton": {
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
      position: "absolute",
      bottom: "19px",
      left: "17px",
      borderRadius: "5px",
      fontWeight: "400",
      fontSize: "13px",
      color: "#151515",
      backgroundColor: "#fff",

    },
  },
  button: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    height: "45px",
    paddingLeft: "17px",
    borderRadius: "12px",
    marginTop: "-30px",
    "&:hover": {
      color: "#fff",
    },
    "& svg": {
      color: "#232B3B",
      fontSize: "20px",
    },
  },

  sideMenuBox: {
    padding: "20px",
    marginBottom: "99px",
    display: "grid",
    gap: "8px"
  },
  logoBox: {
    paddingTop: "28px",
    paddingBottom: "59px",

  },
  innerLogoBox: {
    display: "flex", justifyContent: "center", padding: "19.5px 5px", position: "fixed",
    width: "-webkit-fill-available",
    background: "#fff",
    zIndex: "1", top: "0",
    "@media(max-width:767px)": {
      width: "-webkit-fill-available",
    },
  },
  sublightListItem: {
    color: "rgba(22, 48, 65, 1)",
    padding: "10px 20px 10px 30px !important",
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #00000024",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.3)",
    }
  },
  lightListItemBox:{
    display: "flex",
    alignItems: "center",
    gap: "15px",

  },
  lightListItem: {
    padding: "13px 22px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    gap: "15px",
    justifyContent:"space-between",
    color: "rgba(22, 48, 65, 1)", fontWeight: "500 !important",
    fontSize: "20px !important",
    lineHeight: "25px !important",
    borderRadius: "8px",
    borderBottom: "1px solid #00000024",
    "& .MuiTypography-displayBlock": {
      color: "#fff ",
    },
    "&:hover": {
      background: "linear-gradient(to right, #0b529d 0%, #8caed1 100%)",
      color: "#fff ",
    }
  },
  lightSelectedListItem: {
    color: "#fff",
    padding: "13px 22px",
    display: "flex",
    alignItems: "center",
    gap: "15px",
    cursor: "pointer",
    borderRadius: "8px",
    background: "linear-gradient(to right, #0b529d 0%, #8caed1 100%)",
    fontWeight: "500 !important",
    fontSize: "20px !important",
    lineHeight: "25px !important",
    "& .MuiTypography-displayBlock": {
      color: "#fff ",
    },
    "&:hover": {
      background: "linear-gradient(to right, #0b529d 0%, #8caed1 100%)",
      color: "#fff ",
    }
  },

  darkDailogOpen: {
      width: "100%",
      maxWidth: "500px",
      border: "1px solid rgba(0, 0, 0, 0.5)",
      padding: "30px",
      overflow: "unset",
      background: "rgba(255, 255, 255, 1)",
      borderRadius: "30px",
      boxShadow: "0px 4px 30px 0px rgba(0, 0, 0, 0.16)",
      "& h2": {
        fontWeight: 600,
        fontSize: "22px !important",
        fontFamily: "'Quicksand', sans-serif ",
        lineHeight: "30px !important",
        color: "#163041",
        "@media(max-width:767px)": {
            fontSize: "20px",
            lineHeight: "28px",
            fontWeight: 600,
        },
    },
    "& h3": {
        fontWeight: 500,
        fontSize: "18px !important",
        fontFamily: "'Quicksand', sans-serif ",
        lineHeight: "26px !important",
        color: "#163041",
        "@media(max-width:767px)": {
            fontSize: "16px",
            lineHeight: "22px",
            fontWeight: 500,
        },
    },
    "& h4": {
        fontWeight: 500,
        fontSize: "14px !important",
        fontFamily: "'Quicksand', sans-serif ",
        lineHeight: "18px !important",
        color: "#7C7C7C",
    },
    "& .cancelButton": {
      height: "40px",
      fontWeight: 600,
      fontSize: "16px !important",
      fontFamily: "'Quicksand', sans-serif ",
      lineHeight: "20px !important",
      background: "#fff", color: "#163041",
      border: "1.5px solid #163041",
      borderRadius: "20px"
  },
  "& .confirmButton": {
      borderRadius: "20px",
      height: "40px",
      fontWeight: 600,
      fontSize: "16px !important",
      fontFamily: "'Quicksand', sans-serif ",
      lineHeight: "20px !important",
      background: "#163041", color: "#fff"
  },
      "& .divider": {
        height: "1px",
        background: "rgba(0, 0, 0, 0.08)",
        width: "-webkit-fill-available",
      },
      "& .gridBox": {
        display: "grid",
        gap: "20px",
        overflow: "auto",
      },
  
      // Styles for TextField
      "& .MuiTextField-root": {
        "& .MuiOutlinedInput-root": {
          background: "#fff",
          fontSize: "16px",
          color: "black",
          borderRadius: "12px",
          border: "none",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(216, 216, 216, 1)",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "none",
          },
          "&::placeholder": {
            color: "#010202 !important",
            fontFamily: "'Quicksand', sans-serif",
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "16px",
            lineHeight: "125%",
          },
          "& .MuiInputBase-input": {
            color: "#163041 !important",
            fontFamily: "'Quicksand', sans-serif",
            fontSize: "16px",
            lineHeight: "125%",
            fontWeight: "500",
            padding: "15.5px 16px !important",
            "@media(max-width:900px)": {
              padding: "12px 10px !important",
            },
          },
          "& .MuiOutlinedInput-adornedStart": {
            paddingLeft: "0px",
          },
          "& .MuiOutlinedInput-adornedEnd": {
            paddingRight: "0px",
          },
          "& .MuiOutlinedInput-inputMarginDense": {
            padding: "15.5px 16px !important",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "none",
            },
            "&:hover fieldset": {
              borderColor: "none",
            },
            "&.Mui-focused fieldset": {
              borderColor: "none",
            },
          },
        },
      },
      "& .formikBox": {
        display: "grid",
        gap: "12px",
      },
    
  },
  gapBox: {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },
  innerBox: {
    background: "linear-gradient(to right, #0b529d 0%, #8caed1 100%)",
    padding: "10px 12px",
    borderRadius: "12px",
    border: "0px 0px 1px 0px",
    display: "flex",
    justifyContent: "space-between",
    margin: "15px 12px",
    alignItems: "center"
  },
  listItemText: {
      fontWeight: "500 !important",
      fontSize: "16px !important",
      lineHeight: "25px !important",
  },
  listSubItemText: {
    fontWeight: "500 !important",
    fontSize: "14px !important",
    lineHeight: "18px !important",
    color: "rgba(22, 48, 65, 1)",
    fontFamily: "'Inter', sans-serif"
  },
  addBookMarkText: {
    fontWeight: "500 ",
    fontSize: "12px ",
    lineHeight: "15px ",
    color: "rgba(255, 255, 255, 1)",
    fontFamily: "'Inter', sans-serif"
  },
  listBox: {
    minWidth: "210px",
    "@media(max-width:767px)": {
      minWidth: "200px",
    },
  },
  projectBox: {
    display: "flex",
    alignItems:"center",
    gap: "10px",
    padding: "10px 25px",
    position: "fixed",
    width: "-webkit-fill-available;",
    background: "rgba(255, 255, 255, 1)",
    border: "1px solid rgba(240, 240, 240, 1)",
    zIndex: "1",
    bottom: "0",
    marginBottom:"40px"
  },
  userName:{
    fontWeight: "600",
    fontSize: "16px",
    color: "#081225",
    lineHeight:"20px"
  },
  logoutName:{
    fontWeight: "500",
    fontSize: "14px",
    color: "#163041",
    lineHeight:"18px",
    alignItems: "center",
    display: "flex",
    gap:"6px",
    marginTop:"6px",
    cursor:"pointer"
  },
  editBox: {
    position: "absolute",
    top: "0",
    zIndex: "1",
    width: "-webkit-fill-available",
    overflow: "hidden",
    height: "100%",
    opacity: "0",
  },
 
};

const DownloadIcon = styled("img")(({ theme }) => ({
  width: "55px",
  height: "55px",
  borderRadius: "35px"
}));
const sections1 = [
  {
    items: [
      {
        title: "Layers",
        tabview: "Layers",
        clickable: false,
        icon: "images/NavBarIcon/layer.svg",
        activeIcon: "images/NavBarIcon/layerActive.svg"
      },
      {
        title: "Legend",
        tabview: "Legend",
        clickable: false,
        icon: "images/NavBarIcon/legend.svg",
        activeIcon: "images/NavBarIcon/legendActive.svg"
      },
      // {
      //   title: "Upload Data",
      //   // icon: <BsFillBookmarkFill fontSize={"24px"} />,
      //   tabview: "upload",
      //   clickable: true,
      //   icon:"images/NavBarIcon/bookMarkIcon.svg",
      //    activeIcon:"images/NavBarIcon/bookMarkActiveIcon.svg",
      //   items: [

      //     {
      //       title: "bookmark 1",
      //       // href: "/",
      //       clickable: true,
      //     },
      //     {
      //       title: "bookmark 2",
      //       // href: "/",
      //       clickable: true,
      //     },
      //     {
      //       title: "bookmark 3",
      //       // href: "/",
      //       clickable: true,
      //     },
      //   ],
      // },
      {
        title: "Upload Data",
        tabview: "upload",
        clickable: false,
        icon: "images/NavBarIcon/cloudplus.svg",
        activeIcon: "images/NavBarIcon/cloudplusActive.svg"
      },
      {
        title: "Project Settings",
        tabview: "project settings",
        clickable: false,
        icon: "images/NavBarIcon/projectSetting.svg",
        activeIcon: "images/NavBarIcon/projectSettingActive.svg"
      },
      // {
      //   title: "Arbitrage",
      // icon: <SlLayers />,
      // tabview: "",
      // clickable: true,
      // items: [

      //   {
      //     title: "example",
      //     href: "/",
      //     clickable: true,
      //   },
      // ],
      // },
    ],
  },
];
const NavBar = ({ onMobileClose, openMobile, tabView }) => {
  const themeSeeting = useContext(SettingsContext);
  const sections = [
    {
      items: [
        {
          title: "Dashboard",
          tabview: "dashboard",
          clickable: true,
          icon: <DashboardOutlinedIcon />,
          activeIcon: <DashboardIcon />,
          items: [],
        },
        {
          title: "Sales",
          tabview: "sales",
          clickable: true,
          icon: <ShoppingCartOutlinedIcon />,
          activeIcon: <ShoppingCartIcon />,
          items: [
            { title: "New Sales", href: "/sales/newsales", clickable: true },
            { title: "Order History", href: "/sales/shistory", clickable: true },
            { title: "Reject Sales History", href: "/sales/reject_sales", clickable: true },
            { title: "Epos", href: "/sales/Epos", clickable: true },
            { title: "Sales Report (Epos)", href: "/sales/epos_sales", clickable: true },
            { title: "Quick Order", href: "/sales/Quick_Order", clickable: true },
          ],
        },
        {
          title: "Picking",
          tabview: "picking",
          clickable: true,
          icon: <ListAltOutlinedIcon />,
          activeIcon: <ListAltIcon />,
          items: [
            { title: "Create Picking", href: "/picking/picking_create", clickable: true },
            { title: "Picking List", href: "/picking/picking_list", clickable: true },
            { title: "Picking History", href: "/picking/picking_history", clickable: true },
            { title: "Short QTY", href: "/picking/short_qty", clickable: true },
            { title: "Proforma Invoice", href: "/picking/proforma", clickable: true },
          ],
        },
        {
          title: "Dispatch & Deliveries",
          tabview: "delivery",
          clickable: true,
          icon: <LocalShippingOutlinedIcon />,
          activeIcon: <LocalShippingIcon />,
          items: [
            { title: "Create Manifest", href: "/delivery/route_planing", clickable: true },
            { title: "Manifest List", href: "/manifest_list", clickable: true },
            { title: "Open Trip", href: "/open_trips", clickable: true },
            { title: "Complete Trip", href: "/complete_trips", clickable: true },
          ],
        },
        {
          title: "Master",
          tabview: "master",
          clickable: true,
          icon: <GroupOutlinedIcon />,
          activeIcon: <GroupIcon />,
          items: [
            { title: "Products", href: "/products", clickable: true },
            { title: "Product Price Variation", href: "/products_price_variation", clickable: true },
            { title: "Suppliers", href: "/supplier", clickable: true },
            { title: "Users", href: "/users", clickable: true },
            { title: "Product Categories", href: "/product_category", clickable: true },
            { title: "Brands", href: "/Brands", clickable: true },
            { title: "Units", href: "/Units", clickable: true },
            { title: "Customers", href: "/customers", clickable: true },
            { title: "Contra Price Customers", href: "/ContraList", clickable: true },
          ],
        },
        {
          title: "Reports",
          tabview: "reports",
          clickable: true,
          icon: <BarChartOutlinedIcon />,
          activeIcon: <BarChartIcon />,
          items: [
            { title: "Customer Not Order", href: "/reports/customer_not_order_report", clickable: true },
            { title: "Inventory Sales Report", href: "/reports/inventory_sales_report", clickable: true },
            { title: "MIS Report", href: "/reports/mis_report", clickable: true },
            { title: "Cross Off Report", href: "/reports/missing_order", clickable: true },
            { title: "Sales Rep Report", href: "/reports/sales_report", clickable: true },
            { title: "Profit and Loss", href: "/reports/profit_loss_report", clickable: true },
            { title: "Order Location Report", href: "/reports/lat_long_report", clickable: true },
            { title: "Cashier Report", href: "/reports/Cashier_report", clickable: true },
          ],
        },
        {
          title: "Purchases",
          tabview: "purchases",
          clickable: true,
          icon: <ShoppingCartOutlinedIcon />,
          activeIcon: <ShoppingCartIcon />,
          items: [
            { title: "Purchases Order", href: "/purchases/purchases_order", clickable: true },
            { title: "Purchases History", href: "/purchases/purchases_grn", clickable: true },
          ],
        },
        {
          title: "Account",
          tabview: "account",
          clickable: true,
          icon: <AccountCircleOutlinedIcon />,
          activeIcon: <AccountCircleIcon />,
          items: [
            { title: "Push to Sage", href: "/account/push_sage", clickable: true },
            { title: "All Push Invoice", href: "/account/push_invoice", clickable: true },
            { title: "Received Payments", href: "/account/payments", clickable: true },
            { title: "Customer Accounts", href: "/account/customer_accounts", clickable: true },
            { title: "Supplier Ledger", href: "/account/supplier_ledger", clickable: true },
            { title: "Payment Ledger", href: "/account/payment_ladger", clickable: true },
            { title: "My Ledger", href: "/account/my_ledger", clickable: true },
            { title: "Product Ledger", href: "/account/product_ledger", clickable: true },
            { title: "Stock Take", href: "/stock_take/history", clickable: true },
          ],
        },
        {
          title: "Return",
          tabview: "return",
          clickable: true,
          icon: <AssignmentReturnOutlinedIcon />,
          activeIcon: <AssignmentReturnIcon />,
          items: [
            { title: "Return List", href: "/return_list", clickable: true },
          ],
        },
        {
          title: "Promotion",
          tabview: "promotion",
          clickable: true,
          icon: <LocalOfferOutlinedIcon />,
          activeIcon: <LocalOfferIcon />,
          items: [
            { title: "Promotions", href: "/Promotions/Promos", clickable: true },
          ],
        },
        {
          title: "Incomplete Orders",
          tabview: "incomplete_orders",
          clickable: true,
          icon: <ErrorOutlinedIcon />,
          activeIcon: <ErrorIcon />,
          items: [
            { title: "Incomplete Order List", href: "/sales/IncompleteOrderList", clickable: true },
            { title: "Inventory Report", href: "/sales/InventoryReport", clickable: true },
          ],
        },
      ],
    },
  ];

const navigate = useNavigate();
  const location = useLocation();
  const [isloading, setLoader] = useState(false);
  const [navBarHoverIndex, setNavBarHoverIndex] = useState("");
  const [isOpen, setIsOpen] = useState([]);

  const [expandedSections, setExpandedSections] = useState({});

  // Handle toggle for sublist
  const handleSublistToggle = (index) => {
    setExpandedSections((prev) => (prev === index ? null : index));
    const newOpenState = [...isOpen];
    newOpenState[index] = !newOpenState[index];
    setIsOpen(newOpenState);
  };
  const handleToggle = (index) => {
    setExpandedSections((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  // Handle item click (navigate or perform an action)
  const handleItemClick = (href) => {
    navigate(href);
  };
  const [isLogout, setIsLogout] = useState(false);
  // let isadmin = useSelector((state) => state?.user?.user?.isadmin, shallowEqual);
  // let userName = useSelector((state) => state?.user?.user?.username, shallowEqual);
  // const dispatch = useDispatch();
  const renderedSections = false == true ? sections1 : sections;
  const User = useContext(UserContext);
  // let profileImage = useSelector((state) => state?.user?.user?.profileImage, shallowEqual);

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const handleTabStates = () => {
    User.setLayerTab(true)
    User.setLayerChartTab(false)
    User.setLayerstyleTab(true)
    User.setLegendTab(true)
    User.setUploadTab(true)
    User.setProjectSettingsTab(true)
  }
  const handleImageSelect = (event) => {
    if (event.target.files[0]) {
      handleFormSubmit(event.target.files[0])
    } 
  };
  const handleFormSubmit = async (profileData) => {
    setLoader(true);
    try {
      const formData = new FormData();
      formData.append("profilePhoto", profileData); 
      const res = await axios.patch(ApiConfig.editprofileinfo, formData, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`, 
          "Content-Type": "multipart/form-data", // Indicating form-data type
        },
      });
      if (res.status === 200 || res.status === 201) {
        toast.success("Profile updated successfully");
        const reader = new FileReader();
      reader.onload = () => {
        // dispatch(setProfileImage(reader.result))
      };
      reader.readAsDataURL(profileData);
      }
    } catch (error) {
      toast.error("An error occurred while updating the profile");
      console.error(error);
    } finally {
      setLoader(false);
    }
  };
  
  
  const content = (
    <>
      <Box height="100%" display="flex" flexDirection="column">
        <Box className={styles.logoBox}>
          <Box sx={styles.innerLogoBox}>

            <img
              // onClick={() => navigate('/login')}
              src={`assets/img/${PREFIX}_logo.png`}
              alt="Logo"
              style={{ cursor: "pointer", width: "150px", }}
              onError={(e) => {
                e.target.onerror = null; // Prevents infinite loop if the fallback image fails
                e.target.src = "images/Logo.png"; // Set your fallback image
              }}
            />
          </Box>
        </Box>

        <Box pb={2} pt={"65px"}>
          <Box sx={styles.sideMenuBox}>
            {sections?.[0]?.items?.map((item, index) => {
              const hasSubItems = item.items && item.items.length > 0;
              const isExpanded = expandedSections[index];

              return (
                <div key={`menuItem${index}`}>
                  {/* Main List Item */}
                  <ListItem
                    sx={styles.lightListItem}
                    onClick={() => {
                      if (hasSubItems) {
                        handleToggle(index);
                      } else if (item.clickable) {
                        handleItemClick(item.href);
                      }
                    }}
                  >
                    {/* Icon and Title */}
                    <Box sx={styles.lightListItemBox}>
                        {item.icon}
                      <Typography sx={styles.listItemText}>
                      {item.title}
                    </Typography></Box>
                    <RiArrowDropDownLine />
                  </ListItem>

                  {/* Sub-Items (Collapse) */}
                  {hasSubItems && (
                    <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {item.items.map((subItem, subIndex) => (
                          <ListItem
                            key={`subItem${subIndex}`}
                            sx={styles.sublightListItem}
                            onClick={() => handleItemClick(subItem.href)}
                          >
                            <Typography sx={styles.listSubItemText}>
                              {subItem.title}
                            </Typography>
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  )}
                </div>
              );
            })}
          </Box>
        </Box>
        <Box sx={styles.projectBox}>
          <Box>
            <Typography onClick={()=>{
              setIsLogout(true)
            }} sx={styles.logoutName}><LogoutIcon />Log out</Typography>
          </Box>
        </Box>
        {isLogout && (
          <Dialog
            maxWidth="sm"
            fullWidth
            sx={{
              "& .MuiDialog-paper": styles.darkDailogOpen,
            }}
            open={isLogout}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => setIsLogout(false)}
          >
            <DialogContent>
              <Box className={styles.dialougTitle} align="center">
                <Typography variant="h2"
                  className={"darkHeading"}
                >
                  Logout
                </Typography>
                <Typography variant="h3"
                  className={"darkSubHeading"}
                >
                  Are you sure you want to log out?
                </Typography>
              </Box>
            </DialogContent>
            <DialogActions
              style={{
                display: "block",
              }}
            >
              <Box
                mt={2}
                sx={{
                  textAlign: "center",
                  display:"flex",
                  alignItems:"center",
                  gap:"16px"
                }}
              >
                <Button fullWidth variant="contained"
                  onClick={() => setIsLogout(false)}
                >
                  Cancel
                </Button>
               
                <Button fullWidth variant="contained"
                  className={"darkFilledButton"}
                  onClick={() => {
                    window.localStorage.clear();
                    window.sessionStorage.clear();
                    navigate("/");
                  }}
                >
                  Logout
                </Button>
              </Box>
            </DialogActions>
          </Dialog>
        )}

      </Box>
    </>
  );
  const theme = useTheme();
  const islgUp = useMediaQuery(theme.breakpoints.up(1278));
  return (
    <>
      {/* <Box className={styles.main}></Box> */}

      {!islgUp &&
        <Drawer
          anchor="right"
          sx={{
            paper: styles.desktopDrawer,
          }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          <Box>{content}</Box>
        </Drawer>
      }
      {/* {islgUp &&
        <Drawer
          anchor="right"
          sx={{
            paper: styles.desktopDrawer,
          }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>} */}
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
